<mat-divider></mat-divider>
<main>
  <h4>Measurement system selection</h4>
  <div class="header-text">
    <p>
      Select your preferred measurement system. Please choose carefully, as changes will require
      reaching out to our technical team.
    </p>
  </div>

  <div class="dense">
    <mat-form-field appearance="outline" class="measurement-form-field">
      <mat-label>Preferred measurement system</mat-label>
      <mat-select
        [value]="selectedMeasurementSystem()"
        (selectionChange)="selectedMeasurementSystem.set($event.value)"
        placeholder="Select">
        @for (option of measurementSystemOptions; track option.value) {
          <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <p>
    Clicking "Next" will lock down your measurement system!<br />
    Be certain that this is your preferred method.
  </p>

  <div class="btn-footer">
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="onNextClick()"
      [disabled]="!canSubmit()">
      @if (isSaving()) {
        <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
      } @else {
        <span>Next</span>
      }
    </button>
  </div>
</main>
